module.exports = __webpack_public_path__ + "img/a3.2047c6f.png";